module.exports = __webpack_public_path__ + "img/office-blank.37129f37.jpg";